var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20.25C18.3472 20.25 20.25 18.3472 20.25 16C20.25 13.6528 18.3472 11.75 16 11.75C13.6528 11.75 11.75 13.6528 11.75 16C11.75 18.3472 13.6528 20.25 16 20.25Z",
    stroke: "#6921C4",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9167 7.5H6.08333C4.51853 7.5 3.25 8.76853 3.25 10.3333V21.6667C3.25 23.2315 4.51853 24.5 6.08333 24.5H25.9167C27.4815 24.5 28.75 23.2315 28.75 21.6667V10.3333C28.75 8.76853 27.4815 7.5 25.9167 7.5Z",
    stroke: "#6921C4",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16H24.5142",
    stroke: "#FF6019",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16H7.51417",
    stroke: "#FF6019",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashpay);
export default __webpack_public_path__ + "static/media/cashpay.dac3020a.svg";
export { ForwardRef as ReactComponent };